export const TERMS_OF_SERVICE = 'https://www.trend.io/terms-creators';

export const PRIVACY_POLICY = 'https://www.trend.io/privacy-policy';
